<template>
<div>
    <b-row>
        <b-colxx xxs="12">
            <piaf-breadcrumb :heading="$t('menu.booking-calendar')" />
            <div class="separator mb-5"></div>
        </b-colxx>
    </b-row>

  <b-card class="mb-4" v-if="userRole==='BRAND_ADMIN'">
    <b-row>
      <b-colxx xxs="12" md="4" lg="3" xl="3" class="pr-0" v-if="userRole==='BRAND_ADMIN'">
        <div class="form-group has-float-label">
          <v-select v-model="storeSearchKind" label="label" :options="storeSelectOption"/>
          <span>매장선택</span>
        </div>
      </b-colxx>
      <b-colxx xxs="12" md="6" lg="4" xl="4">
        <b-button @click="onSearch" variant="outline-primary default">
          {{ $t('button.search') }}
        </b-button>
      </b-colxx>
    </b-row>
  </b-card>
<!-- 매장관리자 일 경우-->
  <b-row v-if="this.userRole === 'STORE_MANAGER'">
      <b-colxx xxs="12">
          <b-card>
              <FullCalendar class="demo-app-calendar" ref="fullCalendar" defaultView="dayGridMonth"
                :plugins="calendarPlugins" :header="calendarHeader" :views="calendarViews"
                :buttonText="calendarBuuttonText" :contentHeight="contentHeight"
                :allDaySlot="weekAllDaySlot" :scrollTime="scrollTime" :events="calendarEvents"
                :slotLabelFormat="slotLabelFormat" :slotLabelInterval="slotLabelInterval"
                @eventRender="eventRender" @eventClick="eventClick" @datesRender="datesRender"

            />
          </b-card>
      </b-colxx>
  </b-row>

  <!-- 브랜드 관리자 일 경우-->
  <b-row v-if="this.userRole === 'BRAND_ADMIN' && isSelectedStore">
    <b-colxx xxs="12">
      <b-card>
        <FullCalendar class="demo-app-calendar" ref="fullCalendar" defaultView="dayGridMonth"
                      :plugins="calendarPlugins" :header="calendarHeader" :views="calendarViews"
                      :buttonText="calendarBuuttonText" :contentHeight="contentHeight"
                      :allDaySlot="weekAllDaySlot" :scrollTime="scrollTime" :events="calendarEvents"
                      :slotLabelFormat="slotLabelFormat" :slotLabelInterval="slotLabelInterval"
                      @eventRender="eventRender" @eventClick="eventClick" @datesRender="datesRender"

        />
      </b-card>
    </b-colxx>
  </b-row>
    <!-- 예약조회 모달 -->
    <template>
        <b-row align-v="center" align-h="center" class="mt-0" no-gutters>
            <b-modal id="bookingmodal" ref="bookingmodal" size="xl" title="예약 조회" :hide-backdrop="false" :no-close-on-backdrop="true">
                <booking-modal :dateData="modalSearchDate" :topBookingBtn="false" :calendarType="calendarType"  :calendarTime="calendarTime" :timeUnit="timeUnit" :storeCode="selectStoreCode" :defaultStoreCode="defaultStoreCode"> </booking-modal>
                <template slot="modal-footer">
                    <b-button variant="outline-primary" @click="hideBookingModal">닫기</b-button>
                </template>
            </b-modal>
        </b-row>
    </template>
</div>
</template>

<script>
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import "@fullcalendar/core/main.css";
import "@fullcalendar/daygrid/main.css";
import "@fullcalendar/timegrid/main.css";

import api from "../../constants/api";
import {
    mapGetters,
    mapActions,
    mapMutations
} from "vuex";
import BookingModal from "../../components/Pages/BookingModal";
import vSelect from "vue-select";

export default {
    components: {
        FullCalendar,
        "booking-modal": BookingModal,
        'v-select': vSelect
    },
    data: function () {
        return {
            timeUnit:null,
            modalSearchDate: this.$moment().toDate(),
            searchYearMonth: this.$moment().format("YYYY-MM"),
            searchIncludedDate: this.$moment().format("YYYY-MM-DD"),
            scrollTime: this.$moment().format("HH:mm:ss"),
            calendarPlugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
            calendarHeader: {
                left: "today",
                center: "prev,  title  ,next",
                right: "dayGridMonth,timeGridWeek",
            },
            calendarViews: {
                dayGridMonth: {
                    titleFormat: {
                        year: "numeric",
                        month: "long"
                    },
                },
                timeGridWeek: {
                    titleFormat: {
                        year: "numeric",
                        month: "long"
                    },
                },
            },
            calendarBuuttonText: {
                today: "오늘",
                month: "월간",
                week: "주간",
            },
            weekAllDaySlot: false,
            contentHeight: 600,
            calendarEvents: [],
            slotLabelFormat: {
                hour: "numeric",
                hour12: false,
                minute: "2-digit",
                omitZeroMinute: false,
                meridiem: "short",
            },
            slotLabelInterval: "00:30:00",
            storeCode:'',
            infoData:[],
            calendarType: '',
            calendarTime: this.$moment().format("HH:mm"),
            reservationArrMonth: [],
            reservationArrWeek: [],
            userRole: null,
            storeSelectOption: [],
            selectStoreCode: null,
            storeSearchKind:null,
            defaultStoreCode:null,
            isSelectedStore:false
        };
    },
    computed: {
        ...mapGetters(["currentUser", "siteName"]),
    },
  created() {
    this.userRole = JSON.parse(sessionStorage.getItem('BRAND_USER_INFO')).userRole;
    this.defaultStoreCode = sessionStorage.getItem('storeCode');

    if (this.userRole === 'BRAND_ADMIN') {
      this.getStoreList();
    }
  },
  mounted() {
    console.log(sessionStorage.getItem('storeCode'));

  },
    methods: {
      changeMonth(start, end, currentMonthStartDate) {
        console.log(currentMonthStartDate); // the start date of the current month after changing month by clicking the '<'(previous) or '>'(next) button
      },
      handleDateClick(e){
        console.log(e);
      },
      handleSelect(e){
        console.log(e);
      },

      //조회버튼클릭
      onSearch(info) {
        console.log(info)
        if (this.userRole === 'BRAND_ADMIN') {
          if(this.isSelectedStore === false) {
            this.isSelectedStore = true;
          }
          if (this.storeSearchKind.value !== null || this.storeSearchKind.value !== undefined) {
            console.log("여기 부터 = "+this.storeSearchKind.value);
            this.selectStoreCode = this.storeSearchKind.value;
          }
          this.storeSelectOption.forEach(list => {
            if (list.label === this.storeSearchKind) {
              this.selectStoreCode = list.value;
              console.log("여기 부터2 = "+this.selectStoreCode);

            }
          });
        }
        let calendarApi = this.$refs.fullCalendar.getApi();

        this.bookingslistGetData(calendarApi.view.currentStart, calendarApi);
      },
      getStoreList() {

        const reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.storeList)

        this.$http.get(reqURL, {
          headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
        }).then(res => {
          if (res.data.code === "OK") {
            res.data.data.forEach(data => {
              if (data.enabled) {
                this.storeSelectOption.push(
                  {label: data.storeName, value: data.storeCode}
                );
              }
            });
            sessionStorage.setItem('storeCode', this.storeSelectOption[0].value);
            this.storeSearchKind = this.storeSelectOption[0].label;
          } else {
            throw 400
          }
        }).catch(err => {
          alert(err.response.data.message);
        })
      },

        bookingslistGetData(day,info){

        // 브랜드 관리자일경우 session Storage에 스토어코드가 없으므로 직접설정
        let storeCode = "";
        if(this.selectStoreCode=== null || this.selectStoreCode=== "null" ){
          storeCode = sessionStorage.getItem('storeCode');
        } else if(this.selectStoreCode!==null){
          storeCode = this.selectStoreCode;
        }else {
          storeCode = this.defaultStoreCode;
        }

            // bookingslist
            // console.log(this.info.storeCode)
            const reqURL = api.changeAPI(
                this.siteName,
                api.basicURL + api.order.reserveSummary
            );
            const params = {
                dateFrom: this.$moment(day).format("YYYY-MM-01"),
                dateTo: this.$moment(day).endOf("month").format("YYYY-MM-DD"),
                storeCode: storeCode,
                sortDateType: 'VisitDate',
                dateType: 'VisitDate',
                keywordType: 'NoKeyword',
                keyword: null
            };

            this.$http
                .post(reqURL, params, {
                    headers: {
                        Authorization: `Bearer ${this.currentUser.tokens.access.token}`,
                    },
                })
                .then((res) => {
                    if (res.data.code === "OK") {
                        this.reservationArrMonth = res.data.data;
                        this.reservationArrWeek = res.data.data;
                        if (info.view.type === "dayGridMonth") {
                            this.searchYearMonth = this.$moment(info.view.currentStart).format("YYYY-MM");
                            this.searchMonthlyData();
                        } else if(info.view.type ==='timeGridWeek'){
                            this.searchIncludedDate = this.$moment(info.view.currentStart).format("YYYY-MM-DD");
                            this.searchWeeklyData();
                        }
                    } else {
                        throw 400;
                    }
                })
                .catch((err) => {
                    alert(err.response.data.message);
                });
        },
        hideBookingModal() {
            this.$refs["bookingmodal"].hide();
        },
        showBookingModal() {
            this.$refs["bookingmodal"].show();
        },
        datesRender(info) {
            this.bookingslistGetData(info.view.currentStart, info);
        },
        eventClick(info) {
            var bookingData = JSON.parse(info.event.title);

            // Monthly, Weekly Mode Inventory Click
            if (
                info.event.classNames[0] == "date-inventory" ||
                info.event.classNames[0] == "time-inventory"
            ) {
                this.modalSearchDate = info.event.start;
                this.showBookingModal();
            }

            // Monthly Mode Status Click
            if (info.event.classNames[0] == "date-booking-status") {
                var updateDate = this.$moment(info.event.start).format("YYYY-MM-DD");

                if (bookingData.bookingPaused) {
                    this.resumeBookingDate(updateDate);
                } else {
                    this.stopBookingDate(updateDate);
                }
            }

            if (info.event.classNames[0] == "time-inventory") {
                this.calendarType = 'w';
                this.timeUnit = bookingData.timeUnit;
                this.calendarTime = this.$moment(info.event.start).subtract(15, 'minutes').format("HH:mm");
            } else {
                this.calendarType = 'm'
            }

            // Weekly Mode Status Click
            if (info.event.classNames[0] == "time-booking-status") {
                var updateDate = this.$moment(info.event.start).format("YYYY-MM-DD");

                if (bookingData.bookingPaused) {
                    this.resumeBookingTime(updateDate, bookingData.hour, bookingData.ahalf);
                } else {
                    this.stopBookingTime(updateDate, bookingData.hour, bookingData.ahalf);
                }
            }
        },
        eventRender(info) {
            var bookingData = JSON.parse(info.event.title);
            // console.log(bookingData)
            switch (bookingData.type) {
                case "dateBookingStatus":
                    info.el.firstChild.innerHTML = `<span class="fc-title">${bookingData.bookingStatusTitle}</span>`;
                    break;
                case "dateInventory":
                    info.el.firstChild.innerHTML = `<span class="fc-title">${bookingData.bookedHeadcount} / ${bookingData.totalInventory}</span>`;
                    break;
                case "timeBookingStatus":
                    info.el.firstChild.innerHTML = `<span class="fc-title">${bookingData.bookingStatusTitle}</span>`;
                    break;
                case "timeInventory":
                    info.el.firstChild.innerHTML = `<span class="fc-title">${bookingData.bookedHeadcount} / ${bookingData.totalInventory}</span>`;
                    break;
            }
        },
        getWeeklySlotData(paused) {
            if (paused) {
                return {
                    bookingPaused: true,
                    bookingStatusTitle: "예약마감",
                    bookingStatusColor: "#EAEAEA",
                    inventoryColor: "#F3F3F3",
                };
            } else {
                return {
                    bookingPaused: false,
                    bookingStatusTitle: "예약오픈",
                    bookingStatusColor: "#FFEAEA",
                    inventoryColor: "#FFF8F8",
                };
            }
        },
        searchWeeklyData() {
          // 브랜드 관리자일경우 session Storage에 스토어코드가 없으므로 직접설정
          let storeCode = "";
          if(this.selectStoreCode=== null || this.selectStoreCode=== "null" ){
            storeCode = sessionStorage.getItem('storeCode');
          } else if(this.selectStoreCode!==null){
            storeCode = this.selectStoreCode;
          }else {
            storeCode = this.defaultStoreCode;
          }
            const reqURL = api.changeAPI(
                this.siteName,
                api.basicURL + api.shop.bookingStatusWeekly
            );
            const params = {
                includedDate: this.searchIncludedDate,
                storeCode: storeCode
            };

            this.$http
                .get(reqURL, {
                    params: params,
                    headers: {
                        Authorization: `Bearer ${this.currentUser.tokens.access.token}`,
                    },
                })
                .then((res) => {
                    if (res.data.code === "OK") {
                        var bookingWeeklyData = [];
                        res.data.data.dates.forEach((item) => {
                            item.hours.forEach((hourInfo) => {
                                //시간이 1자리수 이면 안그려지는 현상 2자리수맞춰주기
                                var newHourInfoHour = '';
                                if (hourInfo.hour.toString().length == 1) {
                                    newHourInfoHour = "0" + hourInfo.hour;
                                } else {
                                    newHourInfoHour = hourInfo.hour
                                }
                                var setDateTime = item.date + " " + newHourInfoHour;
                                // 상태변경 버튼과 인벤토리 정보 구분 시간 15분
                                var slotDivisionMinutes = 15;
                                // 예약 단위시간 : M30, M60
                                var addMinutes = hourInfo.timeUnit == "M30" ? 30 : 60;
                                let time00Headcount = 0;
                                let time30Headcount = 0;

                                this.reservationArrWeek.forEach(week => {
                                    if (Number(week.headCounts) !== 0) {
                                        if (this.$moment(week.reservationDate).format("YYYY-MM-DD") === this.$moment(item.date).format("YYYY-MM-DD")) {
                                            week.reservationTimeInfos.forEach(time => {
                                                if (String(time.reservationTime.substring(0, 2)) === String(newHourInfoHour)) {
                                                    if (hourInfo.timeUnit == "M30") {
                                                        if (Number(time.reservationTime.substring(3, 4)) < 3) {
                                                            time00Headcount += time.headCounts;
                                                        } else {
                                                            time30Headcount += time.headCounts;
                                                        }
                                                    } else {
                                                        time00Headcount += time.headCounts;
                                                    }
                                                }
                                            });
                                        }
                                    }
                                });

                                if (hourInfo.min00) {
                                    var bookingSlotInfo = this.getWeeklySlotData(item.bookingPaused || (!item.bookingPaused && hourInfo.min00.bookingPaused));
                                    var slotStartDateTime = this.$moment(setDateTime).format("YYYY-MM-DD HH:mm:ss");
                                    var slotDivisionDateTime = this.$moment(slotStartDateTime).add(slotDivisionMinutes, "minutes").format("YYYY-MM-DD HH:mm:ss");
                                    var slotEndDateTime = this.$moment(slotStartDateTime).add(addMinutes, "minutes").format("YYYY-MM-DD HH:mm:ss");

                                    bookingWeeklyData.push({
                                        classNames: ["time-booking-status"],
                                        title: `{"type": "timeBookingStatus", "bookingStatusTitle": "${bookingSlotInfo.bookingStatusTitle}", "bookingPaused": ${bookingSlotInfo.bookingPaused}, "hour": "${hourInfo.hour}", "ahalf": "false","timeUnit":"${hourInfo.timeUnit}"}`,
                                        start: slotStartDateTime,
                                        end: slotDivisionDateTime,
                                        color: bookingSlotInfo.bookingStatusColor,
                                    }, {
                                        classNames: ["time-inventory"],
                                        title: `{"type": "timeInventory", "bookedHeadcount": "${time00Headcount}", "totalInventory": "${hourInfo.min00.totalInventory}","timeUnit":"${hourInfo.timeUnit}"}`,
                                        start: slotDivisionDateTime,
                                        end: slotEndDateTime,
                                        color: bookingSlotInfo.inventoryColor,
                                    });
                                }

                                if (hourInfo.min30) {
                                    var bookingSlotInfo = this.getWeeklySlotData(item.bookingPaused || (!item.bookingPaused && hourInfo.min30.bookingPaused));
                                    var slotStartDateTime = this.$moment(setDateTime).add(30, "minutes").format("YYYY-MM-DD HH:mm:ss");
                                    var slotDivisionDateTime = this.$moment(slotStartDateTime).add(slotDivisionMinutes, "minutes").format("YYYY-MM-DD HH:mm:ss");
                                    var slotEndDateTime = this.$moment(slotStartDateTime).add(addMinutes, "minutes").format("YYYY-MM-DD HH:mm:ss");

                                    bookingWeeklyData.push({
                                        classNames: ["time-booking-status"],
                                        title: `{"type": "timeBookingStatus", "bookingStatusTitle": "${bookingSlotInfo.bookingStatusTitle}", "bookingPaused": ${bookingSlotInfo.bookingPaused}, "hour": "${hourInfo.hour}", "ahalf": "true","timeUnit":"${hourInfo.timeUnit}"}`,
                                        start: slotStartDateTime,
                                        end: slotDivisionDateTime,
                                        color: bookingSlotInfo.bookingStatusColor,
                                    }, {
                                        classNames: ["time-inventory"],
                                        title: `{"type": "timeInventory", "bookedHeadcount": "${time30Headcount}", "totalInventory": "${hourInfo.min30.totalInventory}","timeUnit":"${hourInfo.timeUnit}"}`,
                                        start: slotDivisionDateTime,
                                        end: slotEndDateTime,
                                        color: bookingSlotInfo.inventoryColor,
                                    });
                                }
                            });
                        });
                        this.calendarEvents = bookingWeeklyData;
                        console.log(this.calendarEvents)

                    } else {
                        throw 400;
                    }
                })
                .catch((err) => {
                    alert(err.response.data.message);
                });
        },
        searchMonthlyData() {
        let storeCode = "";
          if (this.userRole === 'BRAND_ADMIN') {
            if(this.selectStoreCode === null || this.selectStoreCode === undefined){
              storeCode = this.storeSelectOption[0].value;
            }else {
              storeCode = this.selectStoreCode;
            }
          }else {
            storeCode = this.defaultStoreCode;
          }

            const reqURL = api.changeAPI(
                this.siteName,
                api.basicURL + api.shop.bookingStatusMonthly
            );
            const params = {
                yearMonth: this.searchYearMonth,
                storeCode: storeCode
            };

            this.$http
                .get(reqURL, {
                    params: params,
                    headers: {
                        Authorization: `Bearer ${this.currentUser.tokens.access.token}`,
                    },
                })
                .then((res) => {
                    if (res.data.code === "OK") {
                        var bookingMonthlyData = [];
                        // console.log(res.data.data.dates)
                        res.data.data.dates.forEach((item) => {
                            let bookedHeadcount = 0;
                            // console.log(this.reservationArrMonth)
                            this.reservationArrMonth.forEach((el, idx) => {
                                if (this.$moment(el.reservationDate).format("YYYY-MM-DD") === this.$moment(item.date).format("YYYY-MM-DD")) {
                                    bookedHeadcount = el.headCounts;
                                }
                            });

                            var inventoryColor = item.date == this.$moment().format("YYYY-MM-DD") ? "rgba( 252, 248, 227, 0.5 )" : "rgba( 255, 255, 255, 0.5 )";
                            var bookingStatusTitle, bookingStatusColor;
                            if (item.bookingPaused) {
                                bookingStatusTitle = "예약마감";
                                bookingStatusColor = "#EAEAEA";
                            } else {
                                bookingStatusTitle = "예약오픈";
                                bookingStatusColor = "#FFEAEA";
                            }

                            bookingMonthlyData.push({
                                classNames: ["date-booking-status"],
                                title: `{"sort": "1", "type": "dateBookingStatus", "bookingStatusTitle": "${bookingStatusTitle}", "bookingPaused": ${item.bookingPaused}}`,
                                start: item.date,
                                color: bookingStatusColor,
                            }, {
                                classNames: ["date-inventory"],
                                title: `{"sort": "2", "type": "dateInventory", "bookedHeadcount": "${bookedHeadcount}", "totalInventory": "${item.totalInventory}"}`,
                                start: item.date,
                                color: inventoryColor,
                            });
                        });
                        this.calendarEvents = bookingMonthlyData;
                    } else {
                        throw 400;
                    }
                })
                .catch((err) => {
                    alert(err.response.data.message);
                });
        },
        stopBookingDate(stopDate) {
          // 브랜드 관리자일경우 session Storage에 스토어코드가 없으므로 직접설정
          let storeCode = "";
          if(this.selectStoreCode=== null || this.selectStoreCode=== "null" ){
            storeCode = sessionStorage.getItem('storeCode');
          } else if(this.selectStoreCode!==null){
            storeCode = this.selectStoreCode;
          }else {
            storeCode = this.defaultStoreCode;
          }

            const reqURL = api.changeAPI(
                this.siteName,
                api.basicURL + api.shop.bookingDateStop
            );
            const params = {
                date: stopDate,
                storeCode:storeCode
            };

            this.$http
                .post(reqURL, params, {
                    headers: {
                        Authorization: `Bearer ${this.currentUser.tokens.access.token}`,
                    },
                })
                .then((res) => {
                    if (res.data.code === "OK") {
                        this.searchMonthlyData();
                    } else {
                        throw 400;
                    }
                })
                .catch((err) => {
                    alert(err.response.data.message);
                });
        },
        resumeBookingDate(resumeDate) {
          // 브랜드 관리자일경우 session Storage에 스토어코드가 없으므로 직접설정
          let storeCode = "";
          if(this.selectStoreCode=== null || this.selectStoreCode=== "null" ){
            storeCode = sessionStorage.getItem('storeCode');
          } else if(this.selectStoreCode!==null){
            storeCode = this.selectStoreCode;
          }else {
            storeCode = this.defaultStoreCode;
          }

            const reqURL = api.changeAPI(
                this.siteName,
                api.basicURL + api.shop.bookingDateResume
            );
            const params = {
                date: resumeDate,
                storeCode: storeCode
            };

            this.$http
                .post(reqURL, params, {
                    headers: {
                        Authorization: `Bearer ${this.currentUser.tokens.access.token}`,
                    },
                })
                .then((res) => {
                    if (res.data.code === "OK") {
                        this.searchMonthlyData();
                    } else {
                        throw 400;
                    }
                })
                .catch((err) => {
                    alert(err.response.data.message);
                });
        },
        stopBookingTime(stopDate, stopHour, stopAhalf) {

          // 브랜드 관리자일경우 session Storage에 스토어코드가 없으므로 직접설정
          let storeCode = "";
          if(this.selectStoreCode=== null || this.selectStoreCode=== "null" ){
            storeCode = sessionStorage.getItem('storeCode');
          } else if(this.selectStoreCode!==null){
            storeCode = this.selectStoreCode;
          }else {
            storeCode = this.defaultStoreCode;
          }
            const reqURL = api.changeAPI(
                this.siteName,
                api.basicURL + api.shop.bookingTimeSlotStop
            );
            const params = {
                date: stopDate,
                hour: stopHour,
                ahalf: stopAhalf,
                storeCode:storeCode
            };

            this.$http
                .post(reqURL, params, {
                    headers: {
                        Authorization: `Bearer ${this.currentUser.tokens.access.token}`,
                    },
                })
                .then((res) => {
                    if (res.data.code === "OK") {
                        this.searchWeeklyData();
                    } else {
                        throw 400;
                    }
                })
                .catch((err) => {
                    alert(err.response.data.message);
                });
        },
        resumeBookingTime(resumeDate, resumeHour, resumeAhalf) {

          // 브랜드 관리자일경우 session Storage에 스토어코드가 없으므로 직접설정
          let storeCode = "";
          if(this.selectStoreCode=== null || this.selectStoreCode=== "null" ){
            storeCode = sessionStorage.getItem('storeCode');
          } else if(this.selectStoreCode!==null){
            storeCode = this.selectStoreCode;
          }else {
            storeCode = this.defaultStoreCode;
          }
            const reqURL = api.changeAPI(
                this.siteName,
                api.basicURL + api.shop.bookingTimeSlotResume
            );
            const params = {
                date: resumeDate,
                hour: resumeHour,
                ahalf: resumeAhalf,
                storeCode:storeCode
            };

            this.$http
                .post(reqURL, params, {
                    headers: {
                        Authorization: `Bearer ${this.currentUser.tokens.access.token}`,
                    },
                })
                .then((res) => {
                    if (res.data.code === "OK") {
                        this.searchWeeklyData();
                    } else {
                        throw 400;
                    }
                })
                .catch((err) => {
                    alert(err.response.data.message);
                });
        },
    },
};
</script>

<style>
.fc-header-toolbar .fc-center {
    display: flex;
    align-items: center;
}

.fc-button {
    font-size: 1.1em;
}

.fc-header-toolbar .fc-button-primary {
    color: #131113;
    background-color: #fff;
    border-color: #c11314;
}

.fc-header-toolbar .fc-button-primary:active {
    color: #fff;
    background-color: #c11314;
    border-color: #c11314;
}

.fc-header-toolbar .fc-button-primary:not(:disabled).fc-button-active {
    color: #fff;
    background-color: #c11314;
    border-color: #c11314;
}

.fc-content {
    cursor: pointer;
    text-align: center;
}

.time-booking-status {
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2), 0 1px 2px 0 rgba(0, 0, 0, 0.19);
    border-radius: 12px;
    padding-top: 1px;
    margin-top: 1px;
}

.date-booking-status {
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2), 0 1px 2px 0 rgba(0, 0, 0, 0.19);
    border-radius: 12px;
    padding: 2px 1px 2px 1px;
    width: 60%;
    margin-left: 19%;
}

.fc-day-grid-event.date-booking-status .fc-title,
.fc-time-grid-event.time-booking-status .fc-title {
    font-size: 1.2em;
    font-weight: 500;
}

.fc-day-grid-event.date-inventory .fc-title,
.fc-time-grid-event.time-inventory .fc-title {
    font-size: 1.3em;
    font-weight: 900;
    text-decoration: underline;
    text-underline-position: under;
}

.date-inventory {
    margin-top: 10px;
}

.fc-time-grid .fc-slats td {
    height: 3.5em;
    border-bottom: 0;
}
</style>
